module.exports = __webpack_public_path__ + "img/photo_2023-12-01 19.35.01.4470230d.jpg";